
import { SlideContext } from './slideContext';


class SlideMulti {

  constructor({ setState, getState }) {
    this.setState = setState;
    this.getState = getState;
  }

  next = () => {
    const { position, slides, snapToLastElement, visibleItems } = this.getState();
    
    if(position + 1 > slides.length - 1) return;
    if(snapToLastElement && position + 1 > slides.length - visibleItems) return;
    this.setState({ position: position + 1 });
  }
  
  prev = () => {
    const { position } = this.getState();
    
    if(position - 1 < 0) return;
    this.setState({ position: position - 1 });
  }

  goTo = (position) => {
    const { slides, snapToLastElement, visibleItems } = this.getState();
    
    if(position > slides.length - 1) position = slides.length - 1;
    if(snapToLastElement && position > slides.length - visibleItems) position = slides.length - visibleItems;
    if(position < 0) position = 0;
    this.setState({ position });
  }

}

export default SlideMulti;